<template>
  <div>
    <button class="button full-100 is-primary" @click="handlePlayOnWeb()">
      {{ $t('playGameBtn') }}
    </button>
  </div>
</template>

<script>
// import axios from 'axios'

export default {
  name: 'LoginSlotSuperslot',
  props: {
    url: {
      type: String
    },
    account: {
      type: Object
    },
    trigger: {
      type: Number
    }
  },
  watch: {
    trigger: {
      // immediate: true,
      async handler() {
        this.handlePlayOnWeb()
      }
    }
  },
  methods: {
    handlePlayOnWeb() {
      const link = `https://mobile.ambsuperslot.com?username=${this.account.username}&password=${this.account.password}`
      if (process.env.VUE_APP_IFRAME === 'true') {
        const a = document.createElement('a')
        a.setAttribute('href', link)
        a.setAttribute('target', '_blank')
        a.click()
        document.body.appendChild(a)
      } else window.location.href = link
    }
  }
}
</script>

<style scoped lang="scss">
.height-0 {
  height: 0px !important;
  visibility: hidden;
}
</style>
